"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventTarget = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "getEventTarget", { enumerable: true, get: function () { return dom_utilities_1.getEventTarget; } });
//# sourceMappingURL=getEventTarget.js.map